import { useState, useEffect } from "react";
import { FetchInstallmentRatesCFGroups } from "../../api/FetchInstallmentRatesCFGroups";
import { InstallmentRatesCFGroup } from "../../helpers/interfaces/ProvidersInterfaces";

let cachedData: InstallmentRatesCFGroup[] | null = null;

export const useFetchInstallmentRatesCFGroups = () => {
  const [installmentGroups, setInstallmentGroups] = useState<InstallmentRatesCFGroup[]>(cachedData || []);
  const [loading, setLoading] = useState(!cachedData);

  useEffect(() => {
    if (cachedData) {
      return;
    }

    const loadData = async () => {
      setLoading(true);
      const response = await FetchInstallmentRatesCFGroups();

      if (response && response.data) {
        const data: InstallmentRatesCFGroup[] = Array.isArray(response.data) ? response.data : response.data.data || [];
        cachedData = data;
        setInstallmentGroups(data);
      }
      setLoading(false);
    };

    loadData();
  }, []);

  return { installmentGroups, loading };
};
